/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse, ResponseType } from 'axios';

import customAxios from './customAxios';
import { env } from '../constants/env';

function getBaseURL(): string {
  return env.NEXT_PUBLIC_SERVICES_URL || '';
}

/**
 * @description get url by service informed.
 * @param service is the service that fetch requires.
 * @returns base url.
 */

export function getURl(service: string): string {
  const baseURLS: string[] = getBaseURL().split('|') || [];
  const baseURL: string[] =
    baseURLS?.filter((url) => url.includes(service)) || [];
  if (!baseURL[0]) {
    throw Error('url.not.found');
  }
  return baseURL[0].split(';')[1] || '';
}

type TFetchParams = {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  path: string;
  service: string;
  headers?: Record<string, any>;
  params?: Record<string, any>;
  data?: any;
  responseType?: ResponseType;
};
/**
 * @description makes http request according to the informed data.
 * @param param request params.
 * @returns fetch function.
 */
function fetch<T = any>({
  method = 'GET',
  path,
  params,
  headers,
  responseType,
  data,
  service,
}: TFetchParams): Promise<AxiosResponse<T>> {
  return new Promise((resolve, reject) => {
    if (!service) throw Error('url.not.found');
    customAxios({
      headers: {
        ...headers,
      },
      url: `${getURl(service)}${path}`,
      method,
      params,
      responseType,
      data,
      paramsSerializer: {
        indexes: null, // no brackets at all
      },
      // withCredentials: true,
    })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}

export function isLocalHost(): boolean {
  return getURl(getBaseURL()).includes('localhost');
}

export default fetch;
